import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const ZvlastniNabidky = {
	name: NAME,
	apiProvider,
	router,
};
